"use strict";

require("core-js/modules/es.array.map");
require("core-js/modules/es.array.reduce-right");
require("core-js/modules/es.parse-float");
require("core-js/modules/es.regexp.exec");
require("core-js/modules/es.string.replace");
require("core-js/modules/es.string.search");
require("core-js/modules/es.string.split");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.round = round;
exports.toFinanceString = toFinanceString;
exports.toNumber = toNumber;
/**
 * Конвертация числа к финансовому формату по шаблону
 * В случае ошибки входных данных вернет null
 * Пример шаблона — 0,00##
 *  — сепаратор может быть "," или "."
 *  — "0" будут заменен на числа из value
 *  — "#" будет заменен на числа из value, если они больше 0
 * @param {(string|number)} value — строка или число которое нужно конвертировать
 * @param {Object} options — настройки конвертации
 * @param {string} options.template — шаблон форматирования, по умолчания 0,00
 * @example
 * toFinanceString("что-то") => ""
 * toFinanceString(199.998) => "199,99"
 * toFinanceString("123,777", {template: "0,0#"}) => "123,77"
 * toFinanceString("123,7", {template: "0,0#"}) => "123,7"
 * toFinanceString("123,7", {template: "0,00"}) => "123,70"
 */
// eslint-disable-next-line max-statements
function toFinanceString(value, options) {
  if (options === void 0) {
    options = {};
  }
  if (!value && value !== 0 || !/^((\s+)?[^\d.,](\s+)?)?[\d|\s]+([.,]\d+)?$/.test(String(value))) {
    // console.warn(`toFinanceString Переданное значение невозможно сконвертировать: ${value}`);

    return '';
  }
  if (options.template && !/^\d([.,]((\d+)|(#+)|(\*+)|(\d+#+)|(\d+\*+)))?$/.test(options.template)) {
    // console.warn(`toFinanceString Невалидный шаблон строки: ${options.template}`);

    return '';
  }

  // количество символов в группах целой части
  var countGroupInteger = 3;
  var template = options.template || '0,00';
  var numberString = typeof value === 'number' ? "" + value : value.replace(/\s+/g, '');
  var index = numberString.search(/[.|,]/);
  var indexSeparator = index >= 0 ? index : numberString.length;
  var initialInteger = indexSeparator === 0 ? '0' : numberString.substring(0, indexSeparator);
  var getShouldRoundData = function getShouldRoundData() {
    if (!options.shouldRound) {
      return {
        shouldRoundInteger: false,
        shouldSetDivisionalToZero: false
      };
    }
    var valueDivisionalPart = numberString.substring(indexSeparator + 1, indexSeparator + 3);
    var hundredthsValue = ['0', '0'].map(function (el, i) {
      return valueDivisionalPart[i] || el;
    }).join('');
    var shouldRoundInteger = Number(hundredthsValue) >= 95;
    var shouldSetDivisionalToZero = Number(hundredthsValue) <= 4;
    return {
      shouldRoundInteger,
      shouldSetDivisionalToZero
    };
  };
  var _getShouldRoundData = getShouldRoundData(),
    shouldRoundInteger = _getShouldRoundData.shouldRoundInteger,
    shouldSetDivisionalToZero = _getShouldRoundData.shouldSetDivisionalToZero;
  var integerValue = shouldRoundInteger ? "" + (Number(initialInteger) + 1) : initialInteger;
  if (shouldRoundInteger && integerValue.length > initialInteger.length) {
    indexSeparator += 1;
  }
  var getIntegerPart = function getIntegerPart(valueIndex) {
    if (valueIndex === void 0) {
      valueIndex = 0;
    }
    if (indexSeparator > 0 && valueIndex === indexSeparator || indexSeparator === 0 && valueIndex === numberString.length - 1) {
      return '';
    }
    var symbol = integerValue[valueIndex];
    var countCharactersBeforeSeparator = indexSeparator - valueIndex - 1;
    var separator = countCharactersBeforeSeparator >= countGroupInteger && countCharactersBeforeSeparator % countGroupInteger === 0 ? "\xA0" : '';
    return "" + symbol + separator + getIntegerPart(valueIndex + 1);
  };
  var getDivisionalPart = function getDivisionalPart() {
    var templateDivisionalPart = template.substring(2);
    var valueDivisionalPart = numberString.substring(indexSeparator + 1, indexSeparator + 1 + templateDivisionalPart.length);
    var afterSymbol = numberString[indexSeparator + 1 + templateDivisionalPart.length];
    while (valueDivisionalPart.length < templateDivisionalPart.length) {
      valueDivisionalPart = valueDivisionalPart + "0";
    }
    return valueDivisionalPart.split('').reduceRight(function (acc, symbol, symbolIndex) {
      var templateSymbol = templateDivisionalPart[symbolIndex];
      var isLastTemplateSymbol = symbolIndex === templateDivisionalPart.length - 1;
      var shouldRound = isLastTemplateSymbol && afterSymbol && Number(afterSymbol) >= 5;
      var roundedSymbol = shouldRound && Number(symbol) !== 9 ? Number(symbol) + 1 : symbol;
      switch (templateSymbol) {
        case '0':
          {
            if (shouldSetDivisionalToZero || shouldRoundInteger) {
              return valueDivisionalPart.split('').map(function () {
                return '0';
              }).join('');
            }
            return "" + (symbol !== undefined ? roundedSymbol : templateSymbol) + acc;
          }
        case '#':
          {
            var resultSymbol = shouldRoundInteger || shouldSetDivisionalToZero ? '0' : symbol;
            var fullDivisionalPart = numberString.substring(indexSeparator + 1);
            var afterSymbolHasValue = fullDivisionalPart.substring(symbolIndex).split('').some(function (x) {
              return x !== '0';
            });
            if (Boolean(resultSymbol) && resultSymbol !== '0' || afterSymbolHasValue) {
              return "" + roundedSymbol + acc;
            }
            return acc;
          }
        case '*':
          {
            var _resultSymbol = shouldRoundInteger || shouldSetDivisionalToZero ? '0' : symbol;
            var isZeroSymbol = !symbol || _resultSymbol === '0';
            if (isLastTemplateSymbol) {
              return "" + (isZeroSymbol ? '' : roundedSymbol) + acc;
            }
            if (isZeroSymbol) {
              return "" + (acc.length > 0 ? _resultSymbol : '') + acc;
            }
            return "" + _resultSymbol + acc;
          }
        default:
          return acc;
      }
    }, '');
  };
  var hasNegativeSymbol = /^[^\d+]/.test(numberString);
  var integerPart = getIntegerPart(/^[^\d]/.test(numberString) ? 1 : 0);
  var separatorPart = indexSeparator > 0 ? template[1] : '';
  var divisionalPart = getDivisionalPart();
  var isZero = function isZero(x) {
    return /^[0.,]+$/.test(x);
  };
  var result = "" + integerPart + (divisionalPart && separatorPart) + divisionalPart;
  if (hasNegativeSymbol && !isZero(result)) {
    return "\u2212\xA0" + result;
  }
  return result;
}

/**
 * Возвращает число, если передано число или корректная строка.
 * Возвращает NaN, если не удалось распарсить значение как число.
 * @param {string|number} value строка, которую нужно преобразовать в число
 * @param {Object} options — настройки конвертации
 * @param {number} options.fraction — до какого колличества знаков после запятой нужно округлить
 * @example
 * toFloat('0,543'); // returns 0.543
 * toFloat('3,145', true); // returns 3.15
 * toFloat('5 000,152'); // returns 5000.152
 */
function toNumber(value, options) {
  if (options === void 0) {
    options = {};
  }
  if (Number.isFinite(value)) {
    return options.fraction ? round(value, options.fraction) : value;
  }
  if (typeof value !== 'string') {
    return NaN;
  }
  var regexp = /^-?(\d)*([.,]\d*)?$/;
  var formattedStr = value.replace(/\s/g, '').replace(',', '.');
  if (!formattedStr.length || !regexp.test(formattedStr)) {
    return NaN;
  }
  var parsedValue = parseFloat(formattedStr);
  return options.fraction ? round(parsedValue, options.fraction) : parsedValue;
}
function round(value, fraction) {
  if (fraction === void 0) {
    fraction = 0;
  }
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  return Math.round(value * Math.pow(10, fraction)) / Math.pow(10, fraction);
}